"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var store_1 = require("../store");
exports.default = (function (toolbar) {
    var setWorkspaceToolbar = store_1.useActions(function (state) { return state.ui.setWorkspaceToolbar; });
    react_1.useEffect(function () {
        setWorkspaceToolbar(toolbar);
    }, [setWorkspaceToolbar, toolbar]);
});
